<script setup lang="ts">
defineProps({
  showMenu: { type: Boolean, required: true },
  hover: { type: Boolean, default: false },
  position: { type: String, default: 'right' }
})

defineEmits(['closeMenu'])
</script>

<template>
  <div
    v-if="showMenu"
    :class="`menu-dropdown-bg ${hover ? 'bg-hover' : ''}`"
    @click.stop="$emit('closeMenu')"
  />

  <div v-if="showMenu" :class="['menu-dropdown-options', position]"><slot /></div>
</template>

<style scoped lang="scss">
.menu-dropdown-bg {
  position: fixed;
  top: 0;
  left: 0;
  height: 100dvh;
  width: 100dvw;
  z-index: 100;
  cursor: default;
  animation: appear 0.3s ease-out;
}

.bg-hover {
  height: 0;
  width: 0;
}

.menu-dropdown-options {
  border: 1px solid var(--borderM2);
  padding: 12px 0;
  background: white;
  box-shadow: 0 5px 10px 5px rgba(64, 65, 85, 0.1);
  border-radius: 10px;
  min-width: 200px;
  position: absolute;
  top: 35px;
  animation: appearUp 0.3s ease-out;
  z-index: 1000;
  isolation: isolate;
}

.right {
  right: 0;
}

.left {
  left: 0;
}

.menu-dropdown-options > :deep(*) {
  $svgSize: 13px;
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 12px 30px 12px 22px;
  cursor: pointer;
  user-select: none;

  svg {
    height: $svgSize;
    width: $svgSize;
    flex-shrink: 0;
  }

  span {
    display: block;
    white-space: nowrap;
    font-size: 0.92rem;
    flex-shrink: 0;
  }
}

@media (max-width: 600px) {
  .menu-dropdown-bg {
    background-color: rgba(0, 0, 0, 0.5);
  }

  .menu-dropdown-options {
    position: fixed;
    bottom: 10px;
    top: auto;
    right: 5px;
    left: 5px;
    padding: 20px 5px 25px;
    box-shadow: 0 -5px 30px 0 rgba(118, 118, 122, 0.3);
    animation: appearUpSmall 0.3s ease-out;
  }

  .menu-dropdown-options > :deep(*) {
    padding: 15px 25px 15px 20px;
  }
}

@media (hover: hover) {
  .menu-dropdown-options > :deep(*:hover) {
    background-color: var(--bgLight);
  }
}

@keyframes appear {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes appearUp {
  0% {
    transform: translateY(10px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes appearUpSmall {
  0% {
    transform: translateY(50px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
